import React from 'react';
import { IconProps } from '.';

const SvgColoredFaceGood = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path fill='#91D6A7' d='M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11Z' />
      <path
        fill='#396600'
        d='M7.426 14.518c.027.11.714 2.677 4.574 2.677 3.861 0 4.547-2.567 4.574-2.677a.305.305 0 0 0-.145-.338.309.309 0 0 0-.366.047c-.012.011-1.194 1.134-4.063 1.134-2.868 0-4.052-1.123-4.063-1.134a.307.307 0 0 0-.365-.049.306.306 0 0 0-.146.34ZM8.333 11.389c.844 0 1.528-.958 1.528-2.139 0-1.181-.684-2.139-1.528-2.139S6.805 8.07 6.805 9.25c0 1.181.684 2.139 1.528 2.139ZM15.667 11.389c.843 0 1.527-.958 1.527-2.139 0-1.181-.684-2.139-1.527-2.139-.844 0-1.528.958-1.528 2.139 0 1.181.684 2.139 1.528 2.139Z'
      />
    </svg>
  );
};

export default SvgColoredFaceGood;
